<template>
  <div>
    <div
      v-if="generics"
      style="overflow-x: auto; overflow-y: hidden; margin-bottom: 5px; margin-top: 15px"
    >
      <div style="display: flex; margin: 0; align-items: stretch; padding-bottom: 25px">
        <div style="width: 300px; margin-right: 15px">
          <ntn-manage v-model="generics" :ratio="ratio" @onDelete="onDeleteGeneric(index)">
          </ntn-manage>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import NtnManage from '@/components/elements/NtnManage'

export default {
  components: {
    NtnManage
  },
  inject: ['$validator'],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: undefined
    },
    ratio: { type: String, default: 'horizontal' }
  },
  data: function () {
    return {
      generics: undefined
    }
  },
  watch: {
    value: function (newVal) {
      this.generics = newVal
    }
  },
  mounted: function () {
    this.generics = this.value
  },
  methods: {
    convertImageRatio() {
      this.$emit('changeRatio', this.ratio == 'horizontal' ? 'square' : 'horizontal')
    },
    onDeleteGeneric(index) {
      if (this.generics.length == 1) {
        this.$emit('deleteMessage')
      } else {
        this.generics.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentNtnManage.vue